import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/',
)({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/customer/locations/$locationId/electrical/projects/$projectId/overview', params });
    },
});

function RouteComponent() {
    return null;
}
